import {Button} from "../ui/button";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import {Input} from "../ui/input";
import {useState} from "react";
import {FileUploadProps} from "./DragAndUploadFile"
import {postWithToken} from "../../api/apiBase";
import {useAuthInfo} from "@propelauth/react";
import {FileView} from "./files";
import {toast} from "@/src/hooks/use-toast";
import { useToast } from "../ui/use-toast";
import { Link } from "lucide-react";

const pattern = new RegExp(
    // WARNING: Chatgpt generated regex...
    '^(https?:\\/\\/)?' + // protocol (optional)
    '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.?)+[a-zA-Z]{2,})' + // domain name
    '(\\/[-a-zA-Z\\d%_.~+]*)*' + // path (optional)
    '(\\?[;&a-zA-Z\\d%_.~+=-]*)?'  // query string (optional)
);

function validateLink(link: string) {
    return pattern.test(link);
}

export function AddLinkDialog({folder_id, onAddFile}: FileUploadProps) {
    const {accessToken} = useAuthInfo()
    const [name, setName] = useState<string>('');
    const [link, setLink] = useState<string>('');
    const canSubmit = name && validateLink(link)
    const {toast} = useToast()

    const handleSubmit = () => {
        if (accessToken && name && link) {
            let body = {name: name, link: link}
            postWithToken(
                `/files/create_client_link/v1/${folder_id}`,
                JSON.stringify(body), accessToken)
                .then((res: FileView) => {
                    onAddFile(res)
                }).catch((err) => {
                    toast({
                        title: "Error",
                        description: "Failed to add link: " + String(err),
                        variant: "destructive",
                    });
            })
        }
    };

    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button variant="outline">Add Link <Link size={16} className="ml-2"/></Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md" aria-describedby="">
                <DialogHeader>
                    <DialogTitle>Create Link</DialogTitle>
                </DialogHeader>
                <div className=" ">
                    <br/>
                    <label
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                        Link *
                    </label>
                    <Input
                        name="link"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}/>
                    <div>
                        <br/>
                        <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                            Name *
                        </label>
                        <Input
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}/>
                    </div>
                    <br/>
                </div>
                <DialogFooter className="sm:justify-start">
                    <DialogClose asChild>
                        <Button
                            type="button"
                            variant="outline"
                            disabled={!canSubmit}
                            onClick={handleSubmit}
                        >
                            Create Link
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

